import { captureException } from '@sentry/vue'

export default (error) => {
  const status = error?.response?.status ?? null

  const handledStatuses = [401]

  if (!handledStatuses.includes(status)) {
    captureException(error)
  }

  return Promise.reject(error)
}
